function caption_submenu(element_counter) {
	if ($('.angle_down_' + element_counter).hasClass('hidden')) {
		close_submenu('productslist_navigation',element_counter);
	} else {
		open_submenu('productslist_navigation',element_counter);
	}
}

$(document).ready(function() {
	$('.news-list.widget').wh_ajax_loader({
		auto_load			: false,
		loading_html 		: spinner,
		nav_selector		: '.load-next-news',
		next_selector		: '.load-next-news .btn-load-next-news',
		url_attribute		: 'data-next-url',
		on_content_loaded	: function(loader, $next_selector) {
			const url = $next_selector.attr('href');
			window.history.replaceState({},'',url);
		}
	});
	$('.titelliste-append').wh_ajax_loader({
		auto_load			: false,
		loading_html 		: spinner,
		nav_selector		: '.load-next-titel',
		next_selector		: '.load-next-titel .btn-load-next-titel',
		url_attribute		: 'data-next-url',
		on_content_loaded	: function(loader, $next_selector) {
			const url = $next_selector.attr('href');
			window.history.replaceState({},'',url);
		}
	});
	$('.personen-append').wh_ajax_loader({
		auto_load			: false,
		loading_html 		: spinner,
		nav_selector		: '.load-next-persons',
		next_selector		: '.load-next-persons .btn-load-next-persons',
		url_attribute		: 'data-next-url',
		on_content_loaded	: function(loader, $next_selector) {
			const url = $next_selector.attr('href');
			window.history.replaceState({},'',url);
		}
	});
	$('.content-append').wh_ajax_loader({
		auto_load			: false,
		loading_html 		: spinner,
		nav_selector		: '.load-next-content',
		next_selector		: '.load-next-content .btn-load-next-content',
		url_attribute		: 'data-next-url',
		on_content_loaded	: function(loader, $next_selector) {
			const url = $next_selector.attr('href');
			window.history.replaceState({},'',url);
		}
	});
	// Titelliste
	$('.titelliste.widget .url-control').click(function(event){
		const tab		= event.currentTarget.className.split(' ')[3];
		// extract the id for url params
		const widget_id	= function() {
			const element = $(event.currentTarget).closest(".widget.titel");
			if (element.length == 1) {
				match_number = element[0].id.match(/\d+/);
				if (match_number.length == 1) {
					return match_number[0];
				}
				return null;
			}
		}(0)
		if (event.currentTarget.nodeName === "SELECT") {
			return;
		}
		window.location.href = add_url_param(event.currentTarget.name,event.currentTarget.value,tab,widget_id,widget_id);
	});
	$('.titelliste.widget .url-control').change(function(event){
		var tab				= event.currentTarget.className.split(' ')[3];
		if (event.currentTarget.type === "checkbox") {
			if (event.currentTarget.checked == true) {
				var value	= 1;
			} else {
				var value	= 0;
			}
		} else {
			var value		= event.currentTarget.value;
		}
		window.location.href = add_url_param(event.currentTarget.name,value,tab);
	});
	$('.titelliste.widget .url-control-a').click(function(event){
		var name		= event.currentTarget.className.split(' ')[1];
		var ist_aktiv	= event.currentTarget.className.split(' ')[2];
		var tab			= event.currentTarget.className.split(' ')[3];
		if ( name.length >= 4 && name.substr(0,4) === 'bids' ) {
			if (ist_aktiv === 'inaktiv') {
				var value	= event.currentTarget.id.replace("b-","");
			} else {
				var value	= 0;
			}
		}
		if ( name.length >= 4 && name.substr(0,4) === 'tids' ) {
			if (ist_aktiv === 'inaktiv') {
				var value	= event.currentTarget.id.replace("t-","");
			} else {
				var value	= 0;
			}
		}
		if ( name.length >= 4 && name.substr(0,4) === 'eids' ) {
			if (ist_aktiv === 'inaktiv') {
				var value	= event.currentTarget.id.replace("e-","");
			} else {
				var value	= 0;
			}
		}
		if ( name.length >= 9 && name.substr(0,9) === 'stichwort' ) {
			if (ist_aktiv === 'inaktiv') {
				var value	= event.currentTarget.id;
			} else {
				value		= "";
			}
		}
		window.location.href = add_url_param(name,value,tab);
	});
});

function change_url_params(tab) {
	const uri				= new URI();
	const query				= uri.query(true);
	query["tab"]			= tab;
	query["page"]			= 1;
	query["bids"]			= 0;
	query["tids"]			= 0;
	query["eids"]			= 0;
	query["stichwort"]		= '';
	query["sort"]			= 'score+desc';
	query["neuerscheinung"]	= 2;
	uri.query(query);
	window.location.href	= uri.toString();
}

function add_url_param(name,value,tab,param_page_suffix,hash_suffix) {
	const page_suffix			= param_page_suffix ? param_page_suffix : ''
	const uri					= new URI();
	const query					= uri.query(true);
	query[name]					= value;
	query["page" + page_suffix]	= 1;
	query["tab"]				= tab;
	uri.query(query);
	uri.hash("#titlelist-" + hash_suffix);
	return uri.toString();
}

$('.seminar-series.widget .s-url-control').change(function(event) {
    var id = event.currentTarget.id;
    const widget_id = id.split('_')[1];
    if (event.currentTarget.type === "checkbox") {
        if (event.currentTarget.checked == true) {
            var value	= 1;
        } else {
            var value	= 0;
        }
    } else {
        var value		= event.currentTarget.value;
    }
    // keep position: anchor to the control's id
    window.location.href = add_seminar_param(event.currentTarget.name, value, widget_id, '#' + id);
});

$('.seminar-series.widget .search-url-control').change(function(event){
    var value		= event.currentTarget.value;
    var name		= event.currentTarget.name;
    var widget_id	= name.split('_')[1];
    // keep position: anchor to the control's id
    window.location.href = add_seminar_search_param(name, value, widget_id, '#' + event.currentTarget.id);
});

$('.seminar-series.widget .s-url-control-a').click(function(event){
    var value		= event.currentTarget.id;
    var name		= event.currentTarget.name;
    var widget_id	= name.split('_')[1];
    // keep position: anchor to the clicked control (fallbacks handled in helper)
    var anchor = '#' + (event.currentTarget.id || $(event.currentTarget).closest('.seminar-series.widget').attr('id') || ('seminar-series_' + widget_id));
    window.location.href = add_seminar_category_param(name, value, widget_id, anchor);
});
// ...existing code...

function add_seminar_param(name, value, widget_id, anchor) {
    const uri		= new URI();
    const query		= uri.query(true);
    delete query["ss"];
    query[name]		= value;
    query[`page_${widget_id}`]	= "1";
    query["tab"]	= "s";
    uri.query(query);
    uri.hash(anchor || "#seminar-series");
    return uri.toString();
}

function add_seminar_search_param(name, value, widget_id, anchor) {
    const uri = new URI();
    const query = {};
    query[name] = value;
    query[`page_${widget_id}`] = "1";
    query["tab"] = "s";
    uri.query(query);
    uri.hash(anchor || "#seminar-series");
    return uri.toString();
}

function add_seminar_category_param(name, value, widget_id, anchor) {
    const uri		= new URI();
    const query		= uri.query(true);
    delete query["ss"];
    if (query[name] === value) {
        delete query[name];
    } else {
        query[name]		= value;
    }
    query[`page_${widget_id}`]	= 1;
    query["tab"]	= "s";
    uri.query(query);
    uri.hash(anchor || `#seminar-series`);
    return uri.toString();
}

// Generic helper for header.cfm (use when building URLs outside the helpers)
function navigateWithAnchor(url, anchorId) {
	console.log('url and anchor', url, anchorId);
    try {
        var uri = new URI(url);
        if (anchorId) uri.hash('#' + anchorId);
        window.location.href = uri.toString();
    } catch (e) {
        // Fallback if URI.js isn't available for some reason
        if (anchorId) {
            url = (url.split('#')[0]) + '#' + anchorId;
        }
        window.location.href = url;
    }
}
window.navigateWithAnchor = window.navigateWithAnchor || navigateWithAnchor;

function displayInfoText(textId) {
	if ($("#fg-info-text-" + textId).is(":visible") == 0) {
		$("#fg-info-text-" + textId).slideDown('slow');
	} else {
		$("#fg-info-text-" + textId).slideUp('slow');
	}
}

function handleFieldAppearance(foreignFieldID,fieldValues,value,checked=true,ownFieldId=0) {
	if (value === true) {
		value = 'true';
	} else if (value === false) {
		value = 'false';
	}
	valueChecked = false;
	if (ownFieldId !== 0) {
		$("input[name=" + ownFieldId + "]:checked").each(function() {
			valueChecked = true;
			if (fieldValues.includes($(this).val())) {
				$("#field-" + foreignFieldID).removeClass('fg-display-none');
			} else {
				$("#field-" + foreignFieldID).addClass('fg-display-none');
			}
		});
		if (valueChecked === false) {
			$("#field-" + foreignFieldID).addClass('fg-display-none');
		}
	} else {
		if (fieldValues.includes(value) && checked === true) {
			$("#field-" + foreignFieldID).removeClass('fg-display-none');
		} else {
			$("#field-" + foreignFieldID).addClass('fg-display-none');
		}
	}
}

function toggle_kuendigungszeitraumoptionen(type) {
	if (type === 0) {
		$('#kuendigung-datepicker').slideUp();
	} else {
		$('#kuendigung-datepicker').slideDown();
	}
}

/**
 * load text bild widget with cookie consent
 * 
 * @param widget_id	[integer] id of widget
 * @param blocked 	[integer (boolean)] 0 or 1 -> is widget blocked?
 * @param consent 	[string] type of required cookie consent
 */
function load_widget_text_bild_cookie_consent(widget_id,blocked,consent) {
	var blocked = true;
	if (consent === 'statistics' && cookiemanager.accepted_statistics === true) {
	  blocked = false;
	}
	if (consent === 'marketing' && cookiemanager.accepted_marketing === true) {
	  blocked = false;
	}
	$.ajax({
		type: 'GET'
		,url: '/ajax/text_bild_widget'
		,data: 'widget_id=' + widget_id + '&blocked=' + blocked + '&consent=' + consent
		,cache: false
		,async: false
		,success: function(res,textStatus) {
			$('#widget_' + widget_id + ' .widget-body').html(res.trim());
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Beim Laden ist ein Fehler aufgetreten.");
		}
	});
}